/* eslint-disable no-else-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ValeInfo from './ValeInfo';
import useAPIError from '../../hooks/useAPIError';
import { useAppStore } from '../../store/AppContext';
import { useAuthStore } from '../../store/AuthContext';
// import nutricionA from '../../assets/svg/nutriscore-A.svg';
// import nutricionB from '../../assets/svg/nutriscore-B.svg';
// import nutricionC from '../../assets/svg/nutriscore-C.svg';
// import nutricionD from '../../assets/svg/nutriscore-D.svg';
// import nutricionE from '../../assets/svg/nutriscore-E.svg';
import { ValesHelper } from './ValesHelper';
import { HostProvider } from '../../utils/HostProvider';
import ModalConfirmacion from '../../components/ModalConfirmacion';
import { MisDatosConstants } from '../../utils/MisDatosConstants';
import BloqueTexto from './ValeCore/BloqueTexto';
import CuponPromocion from './ValeCore/CuponPromocion';
import CuponNoPromocion from './ValeCore/CuponNoPromocion';
import TypeButton from './ValeCore/TypeButton';
import { FiltersConstants } from '../../utils/FiltersConstants';

type Props = {
  data: {
    tipoLista: number;
    numOferta: string;
    fechaIniVigencia: any;
    fechaFinVigencia: string;
    fechaFinCanjeoDTO: string;
    fechaFinActivacion: string;
    fechaFinCanjeoPromo: string;
    visualizar: boolean;
    activable: boolean;
    gupoInternoVisualizar: string;
    grupoInternoActivacion: string;
    valeEAN: string;
    exclusividad: boolean;
    entregada: boolean;
    canjeada: boolean;
    activada: boolean;
    idioma: string;
    textoReclamo: string;
    textoTitulo: string;
    textoDescripcion1: string;
    textoDescripcion2: string;
    canalActivacion: string;
    canales: object;
    fechaActivacion: string;
    tipoVale: string;
    scoring: number;
    codImpacto: number;
    planAdhesion: number;
    denominacionPlanAdhesion: string;
    soportePostal: number;
    denominacionSoportePostal: string;
    valeDestacado: string;
    estructurasComerciales: object;
    tienda: string;
    fechaCanjeo: any;
    horaCanjeo: any;
    locale: string;
    preferencia: string;
    fechaInicioCanjeo: string;
    showValeEntrega: boolean;
    tipoReclamo: string;
    canalesVisualizacion: object;
    showPopup: boolean;
  };
  cargarVales: () => void;
  valeIndex: number;
  showCondLegales: (show: boolean) => void;
  setPromocion: (show: boolean) => void;
  preActivado: boolean;
};

interface ValesData {
  tipoLista: number;
  numOferta: string;
  fechaIniVigencia: any;
  fechaFinVigencia: string;
  fechaFinCanjeoDTO: string;
  fechaFinActivacion: string;
  fechaFinCanjeoPromo: string;
  visualizar: boolean;
  activable: boolean;
  gupoInternoVisualizar: string;
  grupoInternoActivacion: string;
  valeEAN: string;
  exclusividad: boolean;
  entregada: boolean;
  canjeada: boolean;
  activada: boolean;
  idioma: string;
  textoReclamo: string;
  textoTitulo: string;
  textoDescripcion1: string;
  textoDescripcion2: string;
  canalActivacion: string;
  canales: object;
  fechaActivacion: string;
  tipoVale: string;
  scoring: number;
  codImpacto: number;
  planAdhesion: number;
  denominacionPlanAdhesion: string;
  soportePostal: number;
  denominacionSoportePostal: string;
  valeDestacado: string;
  estructurasComerciales: object;
  tienda: string;
  fechaCanjeo: any;
  horaCanjeo: any;
  locale: string;
  preferencia: string;
  fechaInicioCanjeo: string;
  showValeEntrega: boolean;
  tipoReclamo: string;
  canalesVisualizacion: object;
  showPopup: boolean;
}

const Vale: FC<Props> = ({
  data,
  cargarVales,
  valeIndex,
  showCondLegales,
  preActivado = false,
  setPromocion = false,
}) => {
  const isEroski = HostProvider.isEroski();
  const isEC = data.preferencia === MisDatosConstants.EROSKI_PROMOCION_CAJA;
  const { addError, addErrorBack } = useAPIError();
  const { t } = useTranslation();
  const oferta = data.textoReclamo;
  const unidad = data.tipoReclamo;
  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const [modalPieTxt, setModalPieTxt] = useState('' as string);
  const [showModalInf, setShowModalInf] = useState(false);
  const textPreferActivar = isEC
    ? t('vales.preferencia.cuerpo-eroski-activar')
    : t('vales.preferencia.cuerpo-caprabo-activar');
  const titleCambioPrefer = isEC
    ? t('vales.preferencia.titulo-desde-eroski')
    : t('vales.preferencia.titulo-desde-cliente');
  const buttonCambioPrefer = t('vales.preferencia.boton-activa-confirmar');
  const CUPON_CANJEADO = 3;
  const CUPON_ACTIVADO = 2;
  const CUPON_NO_ACTIVADO = 1;
  const isDestacado = (data.valeDestacado &&
    data.valeDestacado === '1') as boolean;
  const isPromocion = data.tipoLista === 4 && !data.exclusividad;
  const isCanjeado = (data.tipoLista === CUPON_CANJEADO) as boolean;
  const isActivado = (data.tipoLista === CUPON_ACTIVADO) as boolean;
  const isNoActivado = (data.tipoLista === CUPON_NO_ACTIVADO) as boolean;
  let clasesBloqueValeValor = 'bloque-vale__valor';
  if (!isEroski && isDestacado) {
    if (isCanjeado) {
      clasesBloqueValeValor = 'bloque-vale__valor_destacado_canjeado';
    } else {
      clasesBloqueValeValor = 'bloque-vale__valor_destacado';
    }
  }

  let claseBloqueBasico = 'bloque-vale__basico';
  if (isDestacado) {
    claseBloqueBasico = isEroski
      ? 'bloque-vale-container'
      : 'bloque-vale-container_destacado';
  }
  let clasesBloqueValeBasico = '';
  if (isNoActivado) {
    if (isEroski) {
      clasesBloqueValeBasico = `${claseBloqueBasico} u-margin-bottom-small`;
    } else {
      clasesBloqueValeBasico = `${claseBloqueBasico} bloque-vale__especial`;
    }
  } else if (isActivado) {
    clasesBloqueValeBasico = `${claseBloqueBasico} u-margin-bottom-small`;
  } else if (isCanjeado) {
    clasesBloqueValeBasico = `${claseBloqueBasico} u-margin-bottom-small bloque-vale-container__canjeado`;
  }

  const [showModal, setShowModal] = useState(false as boolean);

  const valesHelper = new ValesHelper(0, 0, 0, 0, t, addError, addErrorBack);

  const activarCambioPreferencia = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    valesHelper.handleActivarVale(
      data,
      cargarVales,
      dataApp.lang,
      dataUser,
      t('vales.activarVale'),
    );
  };

  const cargarPopup = (vale) => {
    const { preferencia } = vale;
    if (
      preferencia === '' ||
      preferencia === MisDatosConstants.EROSKI_PROMOCION_CAJA ||
      preferencia === MisDatosConstants.CLIENTE_PROMOCION_CAJA
    ) {
      if (isEroski) {
        setModalPieTxt('vales.preferencia.pie-ec-cd');
      } else {
        setModalPieTxt('caprabo.cupones.preferencia.pie-ec-cd');
      }
      setShowModal(true);
    } else {
      activarCambioPreferencia();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptyMethod = () => {};

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,react-hooks/exhaustive-deps
  const activar = (vale: ValesData) => {
    const optionHidden = document.querySelector(`.vale-state-${vale.valeEAN}`);

    const optionHiddenList = document.querySelectorAll(`input.test`);
    optionHiddenList.forEach((currentValue) => {
      currentValue.setAttribute('value', '0');
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    // eslint-disable-next-line no-unused-expressions
    optionHidden?.setAttribute('value', '1');
    const visibles = document.querySelectorAll('div.visible');
    const vales = document.querySelectorAll(
      `div.bloque-vale__total.vale-${vale.tipoLista}`,
    );

    const valesActivos = document.querySelectorAll('div.active');

    valesActivos.forEach((currentValue) => {
      currentValue.classList.remove('active');
    });

    visibles.forEach((currentValue) => {
      // currentValue.classList.remove('visible');
      currentValue.remove();
    });

    vales.forEach((currentValue) => {
      currentValue.classList.remove('active');
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const padre = document
      .getElementById(`vale-${vale.valeEAN}-${vale.tipoLista}`)
      .closest(`div.vale-${vale.tipoLista}`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    padre.classList.add('active');
    let index = 0;
    let cantItem = 0;
    vales.forEach((currentValue, key) => {
      cantItem += 1;
      if (currentValue === padre) {
        index = key + 1;
      }
    });
    const divDetalle = document.getElementById(
      `valeinfo-${vale.valeEAN}-${vale.tipoLista}`,
    );
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const tempDivDetalle = document.importNode(divDetalle, true) as HTMLElement;
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    tempDivDetalle.setAttribute('id', `valeinfo-${vale.valeEAN}-clon`);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    tempDivDetalle.classList.add('visible');
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    tempDivDetalle.classList.remove('no-active');

    if (window.outerWidth < 992) {
      const index2 = index - 1;
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      vales.item(index2).after(tempDivDetalle);
    }

    if (window.outerWidth > 992 && window.outerWidth < 1200) {
      const index2 = index - 1;
      if ((index - 1) % 2 === 0) {
        if (vales.item(index2 + 1) === null) {
          vales.item(index2).after(tempDivDetalle);
        } else {
          vales.item(index2 + 1).after(tempDivDetalle);
        }
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        vales.item(index2).after(tempDivDetalle);
      }
    }

    if (window.outerWidth > 1199) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let last: number;
      if (index > 0) {
        last = Math.ceil(index / 3.0) * 3;
      } else if (index < 0) {
        last = Math.floor(index / 3.0) * 3;
      } else {
        last = 3;
      }
      if (cantItem < 3) {
        vales.item(cantItem - 1).after(tempDivDetalle);
      } else if (vales.item(last - 1) === null) {
        if (vales.item(last - 2) === null) {
          vales.item(index - 1).after(tempDivDetalle);
        } else {
          vales.item(last - 2).after(tempDivDetalle);
        }
      } else {
        vales.item(last - 1).after(tempDivDetalle);
      }
    }

    tempDivDetalle
      ?.querySelector('span.bloque-vale__close')
      ?.addEventListener('click', () => {
        document?.querySelector('div.detalle-container.visible')?.remove();
        document
          ?.querySelector('.bloque-vale__total.active')
          ?.classList.remove('active');
      });

    tempDivDetalle
      ?.querySelector('a.legal-conditions')
      ?.addEventListener('click', () => {
        showCondLegales(true);
      });

    if (vale.tipoLista === 1) {
      tempDivDetalle
        ?.querySelector('button.activate-button')
        ?.addEventListener('click', () => {
          cargarPopup(vale);
        });
    }
  };

  const getTotalElementShowedByType = (type: number) => {
    if (type === 1) {
      return document.querySelectorAll('div.vale-1.show').length;
    }
    if (type === 2) {
      return document.querySelectorAll('div.vale-2.show').length;
    }
    if (type === 3) {
      return document.querySelectorAll('div.vale-3.show').length;
    }
    return document.querySelectorAll('div.vale-4.show').length;
  };

  const divNameValeShowHide = () => {
    const bloqueVale = isPromocion && 'bloque-vale__promocion';
    const isValeIndexGreaterOrEqualNine =
      valeIndex < FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO ||
      (getTotalElementShowedByType(data.tipoLista) -
        FiltersConstants.NUM_CUPONES_MOSTRADOS_AL_INICIO) %
        FiltersConstants.NUM_CUPONES_BTN_VER_MAS >
        0;
    const isValeIndexZeroOrEroski =
      (valeIndex + 1) % FiltersConstants.NUM_CUPONES_POR_LINEA === 0 &&
      isEroski;

    return `bloque-vale__total ${bloqueVale} vale-${data.tipoLista}
                ${
                  isValeIndexGreaterOrEqualNine
                    ? ` ${FiltersConstants.SELECTOR_CUPONES_VISIBLES}`
                    : ` ${FiltersConstants.SELECTOR_CUPONES_OCULTOS}`
                }
                ${isValeIndexZeroOrEroski && 'reset-margin-xl'}`;
  };

  const handleShowModalInf = () => {
    if (!preActivado) {
      setShowModalInf(!showModalInf);
    }
  };

  const eliminarInfoCupon = () => {
    const infoCuponVisible = document.querySelector('div.visible');
    if (infoCuponVisible) {
      const idCuponInfo = infoCuponVisible.id.split('-')[1];
      const cupon = document.querySelector(`[data-id='${idCuponInfo}']`);
      const isCuponFiltrado = idCuponInfo !== data.valeEAN && cupon === null;
      if (isCuponFiltrado) {
        const infoCupon = document.getElementById(
          `valeinfo-${idCuponInfo}-clon`,
        );
        infoCupon?.classList.remove('visible');
        infoCupon?.classList.remove('active');
        infoCupon?.remove();
      }
    }
  };

  useEffect(() => {
    const clonActive = document.getElementById(`valeinfo-${data.valeEAN}-clon`);
    if (clonActive) {
      activar(data);
    }
    if (showModalInf) {
      activar(data);
      setShowModalInf(false);
    } else if (
      !showModal &&
      !showModalInf &&
      clonActive === null &&
      data !== null
    ) {
      eliminarInfoCupon();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModalInf, activar, data]);

  const divNameEtiquetaDestacado = () => {
    if (data?.valeDestacado === '1') {
      return (
        <div
          className={`etiqueta__destacado${
            // eslint-disable-next-line no-nested-ternary
            HostProvider.isCaprabo()
              ? data.canjeada
                ? '_caprabo-canjeado'
                : '_caprabo'
              : data.canjeada
              ? '-canjeado'
              : ''
          }
                    }`}
        >
          {t('vales.destacado').toUpperCase()}
        </div>
      );
    }
    return null;
  };
  const divNameValeActivado = () => {
    // eslint-disable-next-line no-nested-ternary
    return !isPromocion
      ? data.tipoLista !== 1
        ? ' bloque-vale-content  vale-activado '
        : ' bloque-vale-content '
      : ' promocion ';
  };

  return (
    <>
      <div
        id={`vale-${data.valeEAN}-${data.tipoLista}`}
        className={divNameValeShowHide()}
        data-valeindex={valeIndex}
        data-tipolista={data.tipoLista}
        data-id={data.valeEAN}
      >
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <div
          className={`bloque-vale ${clasesBloqueValeBasico}`}
          onClick={handleShowModalInf}
        >
          {divNameEtiquetaDestacado()}

          {HostProvider.isEroski() && (
            <div className="divider divider__img--v" />
          )}

          <div className={divNameValeActivado()}>
            {isPromocion && (
              <CuponPromocion
                setPromocion={setPromocion}
                showCondLegales={showCondLegales}
                isEroski={isEroski}
                data={data}
                dataApp={dataApp}
                oferta={oferta}
                unidad={unidad}
              />
            )}
            {!isPromocion && (
              <CuponNoPromocion
                isPromocion={isPromocion}
                oferta={oferta}
                unidad={unidad}
                data={data}
                dataApp={dataApp}
                clasesBloqueValeValor={clasesBloqueValeValor}
              />
            )}
            <BloqueTexto
              data={data}
              isEroski={isEroski}
              isPromocion={isPromocion}
              isDestacado={isDestacado}
            />
          </div>
        </div>
        <TypeButton data={data} cargarPopup={cargarPopup} />
        {!isPromocion && <ValeInfo vale={data} />}
      </div>

      {showModal && (
        <ModalConfirmacion
          isBig={false}
          isOro={false}
          isSmall
          textCentered
          showModal={showModal}
          setShowModal={setShowModal}
          title={titleCambioPrefer}
          textHTMLContent={t(textPreferActivar)}
          doAceptar={activarCambioPreferencia}
          doClose={emptyMethod}
          showCancel
          hideXButton={false}
          acceptButtonTextKey={buttonCambioPrefer}
          pie={t(modalPieTxt)}
        />
      )}
      {/* *** Para control en el test del componente ************************** */}
      <input
        className={`vale-state-${data.valeEAN} test`}
        type="hidden"
        value="0"
      />
      {/*  **************************** */}
    </>
  );
};
export default Vale;
